export default __webpack_public_path__ + "static/char-32-04e8caf0510f5b6f27e002bfb9d411f4.webp";